<template lang="pug">
div
    .modal-solicitacao-nova-analise
        .subtitle CAR: {{ codigoImovel }}
        text-area-input-component.campo-form(
            v-model='justificativa',
            label='Justificativa*:',
            placeholder=''
        )
        el-divider
    .rodape
        button-component.botao-cancelar(label='Cancelar', icon='mdi-close', @click.native='$emit("close")')
        button-component(label='Solicitar', icon='mdi-check', @click.native='solicitar')
</template>

<script>
import { solicitarNovaAnalise } from '@/services/processo.service';

export default {
    props: {
        codigoImovel: {
            type: String,
            required: true,
        },
        idProcesso: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            justificativa: null,
        };
    },
    methods: {
        async solicitar() {

            if (!this.justificativa || this.justificativa === '') {
                this.$notify({
                    title: 'Erro!',
                    message: 'A justificativa é obrigatória.',
                    showClose: true,
                    type: 'error'
                });
                return;
            }
            
            try {
                await solicitarNovaAnalise(this.idProcesso, this.justificativa);

                this.$emit('atualizar');
                this.justificativa = null,

                this.$notify({
                    title: 'Sucesso!',
                    message: 'A solicitação foi realizada com sucesso!',
                    showClose: true,
                    type: 'success'
                });
            } catch (error) {
                this.$notify({
                    title: 'Erro!',
                    message: 'Ocorreu um erro ao tentar realizar a solicitação.',
                    showClose: true,
                    type: 'error'
                });
            }

        },
    },
};
</script>

<style scoped lang="scss">
.subtitle {
    margin-top: 20px;
    font-weight: bold;
    font-size: 15px;
    color: #3d3d3d;
}

.campo-form {
    padding: 20px 0px;
}

.botao-cancelar {
    background-color: #ddd !important;
    color: #666 !important;
}

.rodape {
    display: flex;
    justify-content: space-between;
}

</style>
